import React, { useMemo, useState } from 'react';
import { DebounceInput } from 'react-debounce-input';
import { Collapsible, InfiniteList  } from '../../components';
import { Button, SearchInput } from '../../components/ui';
import { STEPS } from '../constants';
import { SellRequest } from './SellRequest';
import { useOrderManagement } from '../useOrderManagement';
import { SectionTrigger } from './SectionTrigger';

import './assign-sell-requests.scss';

export function AssignSellRequests({
  step,
  lastStep,
  isPxOrder,
  client,
  sellRequests,
  skipSellRequests,
  goToSummary,
}) {
  const {
    pxLinkedSellRequests = [],
    isInline,
    assignSellRequestsOpen,
    setAssignSellRequestsOpen,
    sellRequestsSkipped,
  } = useOrderManagement();
  const [query, setQuery] = useState('');

  const filters = useMemo(() => (
    {
      status: '',
      channel: '',
      admin: '',
      showDeleted: false,
      search: query,
      owner: 'dao',
      excludePx: true,
    }
  ), [query]);

  if (!isInline && (lastStep < STEPS.ASSIGN_SELL_REQUESTS || !isPxOrder)) {
    return null;
  }

  const collapsibleProps = isInline
    ? {
        open: assignSellRequestsOpen,
        handleTriggerClick: () => setAssignSellRequestsOpen((v) => !v),
      }
    : { open: step === STEPS.ASSIGN_SELL_REQUESTS };

  return (
    <Collapsible
      trigger={
        <SectionTrigger
          icon="assign"
          label={`Assign Sell Requests${
            sellRequests?.length ? ` (${sellRequests.length})` : ""
          }`}
        />
      }
      {...collapsibleProps}
    >
      <div className="assign-sell-requests">
        <div className="row large">
          <div className="col-md-6 col-8">
            <DebounceInput
              element={SearchInput}
              debounceTimeout={300}
              forceNotifyByEnter={false}
              size="lg"
              name="search"
              autoComplete="off"
              placeholder="Search"
              value={query}
              onChange={(e) => setQuery(e.target.value)}
            />
          </div>
          <div className="col-md-6 col-4">
            {/* lg = the SearchInput beside it (DS: one size per row). */}
            <Button variant="secondary" size="lg" data-btn="sellreq-confirm-skip" onClick={skipSellRequests}>
              Skip
            </Button>
          </div>
        </div>

        {pxLinkedSellRequests.length > 0 && (
          <div className="px-linked-sell-requests mt-3">
            <div className="px-linked-sell-requests__heading">
              PX Sell Requests on this Order Request
            </div>
            <div className="orders">
              {pxLinkedSellRequests.map((item) => (
                <SellRequest key={`px-${item.id}`} item={item} />
              ))}
            </div>
          </div>
        )}

        <div className="sell-requests-list-container">
          <div className="sell-requests-list" id="sell-requests-list">
            <InfiniteList
              className="orders"
              fetchUrl={`/api/user/${client.id}/requests/sell`}
              fetchParams={{ filters }}
              emptyText={`You don't have requests yet`}
              ItemComponent={SellRequest}
              scrollableTarget="sell-requests-list"
            />
          </div>
        </div>
      </div>

      <div className="action-buttons text-right mt-4">
        <Button
          variant="primary"
          data-btn="sellreq-confirm"
          disabled={!sellRequests?.length}
          onClick={goToSummary}
        >
          Proceed
        </Button>
      </div>
    </Collapsible>
  );
}
